import { Container, ContainerHeader, ContainerContent } from 'components/Containers/Containers'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { ISelectValue } from 'constants/globalTypes'
import { useMemo } from 'react'
import { toast } from 'react-toastify'
import { Button, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import { IAddOperationPlanTab, IOperationPlanState } from 'types/operationPlans.interface'

export const Horizon = ({ setStep, setState, state }: IAddOperationPlanTab) => {

    const handleNext = () => {
        if (!state.horizon?.horizonType?.value && !state.horizon?.schedulerRunFreqMin && !state.horizon?.replenishThreshold && !state.horizon?.maxQueueSize) {
            setStep(6)
        } else if (checkIfAnyHorizonValueIsFilled && (!state.horizon?.schedulerRunFreqMin || !state.horizon?.replenishThreshold || !state.horizon?.maxQueueSize || !state.horizon?.horizonType?.value)) {
            toast.warn('Either all or none of the horizon values must be filled')
            return
        } else {
            setStep(6)
        }
    }

    const handleSelect = (v: ISelectValue, n: string) => {
        setState((prev: IOperationPlanState) => ({ ...prev, horizon: { ...prev.horizon, [n]: v } }))
    }

    const handleBack = () => setStep(4)

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, valueAsNumber } = e.target
        setState((prev: IOperationPlanState) => ({ ...prev, horizon: { ...prev.horizon, [name]: valueAsNumber } }))
    }

    const checkIfAnyHorizonValueIsFilled = useMemo(() => {
        return Object.values(state.horizon).some((value) => value !== null)
    }, [state.horizon])

    return (
        <>
            <Container>
                <ContainerHeader>
                    <TitleText>Horizon</TitleText>
                </ContainerHeader>
                <ContainerContent>
                    <Flex gap='1rem'>
                        <HonestSelectInput
                            options={[
                                { label: 'Next Hours', value: 1 },
                                { label: 'Next Shift', value: 2 },
                            ]}
                            labelText='Existing phases'
                            name='horizonType'
                            onChange={handleSelect}
                            defaultValue={state.horizon?.horizonType?.value}
                            invalid={checkIfAnyHorizonValueIsFilled && !state.horizon?.horizonType?.value}
                            required={checkIfAnyHorizonValueIsFilled}
                        />
                        <Input
                            labelText='Scheduler run frequency (minutes)'
                            name='schedulerRunFreqMin'
                            value={state.horizon?.schedulerRunFreqMin}
                            onChange={handleChange}
                            invalid={checkIfAnyHorizonValueIsFilled && !state.horizon?.schedulerRunFreqMin}
                            required={checkIfAnyHorizonValueIsFilled}
                            type='number'
                            allowZero
                            placeholder='15...'

                        />
                        <Input
                            labelText='Replenish threshold'
                            name='replenishThreshold'
                            value={state.horizon?.replenishThreshold}
                            onChange={handleChange}
                            invalid={checkIfAnyHorizonValueIsFilled && !state.horizon?.replenishThreshold}
                            required={checkIfAnyHorizonValueIsFilled}
                            type='number'
                            allowZero
                            placeholder='4'
                        />
                        <Input
                            labelText='Max queue size'
                            name='maxQueueSize'
                            value={state.horizon?.maxQueueSize}
                            onChange={handleChange}
                            invalid={checkIfAnyHorizonValueIsFilled && !state.horizon?.maxQueueSize}
                            required={checkIfAnyHorizonValueIsFilled}
                            type='number'
                            allowZero
                            placeholder='10'
                        />
                    </Flex>
                </ContainerContent>
            </Container>
            <Flex gap='1rem' mt='32' justend>
                <Button onClick={handleBack}>Back</Button>
                <Button orange onClick={handleNext}>
                    Next
                </Button>
            </Flex>
        </>
    )
}
